export default function _alertBanner() {
    // Check if the module exists before doing anything
    const alertBannerComponentExists =
        !!document.querySelector('.alert-banner');

    // If the module exists, do whatever we need to
    if (alertBannerComponentExists) {
        // Your code here
        console.log('Alert banner custom JS');

        const alertBanner = document.querySelector('.alert-banner');
        const closeAlertBtn = document.querySelector('.alert-banner__close');

        closeAlertBtn.addEventListener('click', (e) => {
            e.preventDefault();
            window.sessionStorage.setItem('alert-banner', 'hide');
            console.log('Alert banner closed');
            alertBanner.classList.add('alert-banner--hide');
        });

        if (window.sessionStorage.getItem('alert-banner') === 'hide') {
            alertBanner.classList.add('alert-banner--hide');
        }
    }
}
_alertBanner();
